import questionBank from './quadrilateralQuestions.json';

export const QUESTION_BANK = questionBank;

export const LENGTH_OPTIONS = [
  { id: 'short', label: 'Quick check', description: '~10 min warm-up', questions: 12 },
  { id: 'standard', label: 'Standard set', description: 'Default mix of drills', questions: 24 },
  { id: 'extended', label: 'Extended challenge', description: 'Deeper mastery sprint', questions: 36 },
];

export const DEFAULT_LENGTH_ID = 'standard';

export const SUBJECTS = [
  {
    id: 'math-geometry',
    label: 'Geometry Lab',
    tagline: 'Quadrilateral mastery sprints',
    badge: 'Mathematics',
    accent: '📐',
  },
];

const MODULE_TEMPLATE = [
  {
    id: 'quad-foundations',
    subjectId: 'math-geometry',
    title: 'Quadrilateral Foundations',
    summary: 'Definitions, diagonals, and quick property checks.',
    focus: 'Fundamental recall & vocabulary',
  },
  {
    id: 'quad-studio',
    subjectId: 'math-geometry',
    title: 'Reasoning Studio',
    summary: 'Angle relationships, sum tricks, and comparison clues.',
    focus: 'Explain your thinking',
  },
  {
    id: 'quad-challenge',
    subjectId: 'math-geometry',
    title: 'Challenge Circuit',
    summary: 'Multi-step puzzles plus proof-style prompts.',
    focus: 'Competition prep',
  },
];

const withModuleStats = MODULE_TEMPLATE.map((module) => {
  const pool = QUESTION_BANK.filter((question) => question.moduleId === module.id);
  const difficulties = pool.map((question) => question.difficulty).filter((level) => Number.isFinite(level));
  const min = difficulties.length ? Math.min(...difficulties) : null;
  const max = difficulties.length ? Math.max(...difficulties) : null;
  return {
    ...module,
    questionCount: pool.length,
    difficultyRange: min !== null && max !== null ? `Level ${min}–${max}` : null,
  };
});

export const MODULES = withModuleStats;

export const getSubjectById = (subjectId) => SUBJECTS.find((subject) => subject.id === subjectId) || null;

export const getModulesForSubject = (subjectId) =>
  MODULES.filter((module) => module.subjectId === subjectId);

export const getModuleById = (moduleId) => MODULES.find((module) => module.id === moduleId) || null;

export const buildQuestionPool = ({ subjectId, moduleIds }) => {
  const modulesArray = Array.isArray(moduleIds)
    ? moduleIds.filter(Boolean)
    : moduleIds
    ? [moduleIds]
    : [];
  const moduleSet = modulesArray.length ? new Set(modulesArray) : null;
  return QUESTION_BANK.filter((question) => {
    if (subjectId && question.subjectId !== subjectId) return false;
    if (moduleSet && !moduleSet.has(question.moduleId)) return false;
    return true;
  });
};
